import React from 'react'
import './loding.css';
export default function Loding() {
    return (
        <div className="loding">
            <div className="spinner">
                <div className="rect1" />
                <div className="rect2" />
                <div className="rect3" />
                <div className="rect4" />
                <div className="rect5" />
            </div>
        </div>
    )
}
